import { call, put, takeEvery } from 'redux-saga/effects'

import * as Api from '../api/sidebar-api';

function* fetchSidebarConfig(action) {
    try {
        const config = yield call(Api.fetchSidebarConfig);
        yield put({
            type: 'SIDEBAR_CONFIG_FETCH_SUCCEEDED',
            payload: { config }
        });
    } catch (e) {
        yield put({
            type: 'SIDEBAR_CONFIG_FETCH_FAILED',
            payload: {
                message: e.message || e
            }
        });
    }
}

function* expandSidebar(action) {
    try {
        yield call(Api.expandSidebar);
        yield put({
            type: 'SIDEBAR_EXPAND_SUCCEEDED'
        });
    } catch (e) {
        yield put({
            type: 'SIDEBAR_EXPAND_FAILED',
            payload: {
                message: e.message || e
            }
        });
    }
}

function* collapseSidebar(action) {
    try {
        yield call(Api.collapseSidebar);
        yield put({
            type: 'SIDEBAR_COLLAPSE_SUCCEEDED'
        });
    } catch (e) {
        yield put({
            type: 'SIDEBAR_COLLAPSE_FAILED',
            payload: {
                message: e.message || e
            }
        });
    }
}

function* watchGetSidebarConfig() {
    yield takeEvery('SIDEBAR_CONFIG_FETCH_REQUESTED', fetchSidebarConfig);
}

function* watchSidebarExpand() {
    yield takeEvery('SIDEBAR_EXPAND_REQUESTED', expandSidebar);
}

function* watchSidebarCollapse() {
    yield takeEvery('SIDEBAR_COLLAPSE_REQUESTED', collapseSidebar);
}

export default [watchGetSidebarConfig, watchSidebarExpand, watchSidebarCollapse];
